export default status => {
  if (status === 'SUBMITTED') {
    return '#099075';
  } if (status === 'PENDING') {
    return '#D17621';
  } return '#D17621';
};
